import React from 'react';
import './home.css';
import appstoreBadge from './img/btn-apple-download.svg';
import appIcon from './img/appIcon.webp';
import Screenshots from '../screenshots/screenshots.js';

const APP_STORE_URL = 'https://apps.apple.com/app/id554531726?mt=8';

const AppStoreLink = ({ campaign, noteClassName = '' }) => (
  <div className="store-cta">
    <a
      href={`${APP_STORE_URL}&ct=${campaign}`}
      className="app-store-link"
      aria-label="Download Igrecway Hangman free on the App Store"
    >
      <img
        src={appstoreBadge}
        alt="Download Igrecway Hangman on the App Store"
        width="160"
        height="53"
      />
    </a>
    <p className={`store-note ${noteClassName}`.trim()}>
      Free download · Requires iOS 17.6 or later
    </p>
  </div>
);

const Home = () => {
  return (
    <div className="home">
      <section className="hero" aria-labelledby="hero-title">
        <div className="container hero-grid">
          <div className="hero-copy">
            <p className="product-lockup">
              <img
                src={appIcon}
                alt=""
                width="100"
                height="100"
                className="hero-icon"
              />
              <span>Igrecway Hangman</span>
            </p>
            <p className="eyebrow">Free · No ads · No in-app tracking</p>
            <h1 id="hero-title">Classic Hangman, without the distractions.</h1>
            <p className="hero-lead">
              Guess words, build your vocabulary, and get a hint when you
              need one. Play free on iPhone and iPad—with no ads, accounts,
              or in-app data collection.
            </p>
            <AppStoreLink campaign="website_hero" />
          </div>
          <div className="hero-visual">
            <Screenshots />
          </div>
        </div>
      </section>

      <section className="trust-strip" aria-label="Product promises">
        <div className="container">
          <ul>
            <li>Free to download</li>
            <li>No ads</li>
            <li>No account</li>
            <li>No in-app data collected</li>
          </ul>
        </div>
      </section>

      <section className="benefits section" aria-labelledby="benefits-title">
        <div className="container">
          <p className="section-kicker">Simple by design</p>
          <h2 id="benefits-title">A familiar game with thoughtful extras</h2>
          <p className="section-intro">
            Everything you need for a quick word challenge, with none of the
            noise that gets between you and the game.
          </p>
          <div className="benefit-grid">
            <article className="benefit-card">
              <span className="benefit-icon" aria-hidden="true">1</span>
              <h3>Play at your pace</h3>
              <p>
                Choose easy or hard mode and switch between the main
                dictionary and a simpler word list.
              </p>
            </article>
            <article className="benefit-card">
              <span className="benefit-icon" aria-hidden="true">?</span>
              <h3>Learn as you play</h3>
              <p>
                Use hints and definitions to discover new words, strengthen
                spelling, and keep the game moving.
              </p>
            </article>
            <article className="benefit-card">
              <span className="benefit-icon" aria-hidden="true">✓</span>
              <h3>Private by design</h3>
              <p>
                Play without advertisements, accounts, in-app tracking, or
                personal data collection.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="closing-cta section" aria-labelledby="closing-title">
        <div className="container">
          <div className="closing-cta-card">
            <div>
              <p className="section-kicker">Your next word is waiting</p>
              <h2 id="closing-title">Ready for another word?</h2>
              <p>
                Download Igrecway Hangman and start playing in seconds.
              </p>
            </div>
            <AppStoreLink
              campaign="website_footer"
              noteClassName="store-note-dark"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
